module.exports = __webpack_public_path__ + "img/ambassador-2.6548e471.png";